import { render, staticRenderFns } from "./MlSidebar.vue?vue&type=template&id=30252668&scoped=true&"
import script from "./MlSidebar.vue?vue&type=script&lang=js&"
export * from "./MlSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30252668",
  null
  
)

export default component.exports